/* 多语言 */
export const LocaleMap = {
  en: 1, //英语 默认语言
  hk: 4, //繁体
  // id: 5, //印尼
  pt: 11, //巴西
  es: 12, //西班牙
  // kr: 60, //韩国
  ph: 61, //菲律宾
  // jp: 62, //日本
  hi: 63, //印度
  ru: 64, //俄罗斯
  // bd: 65, //孟加拉
  // my: 66, //马来西亚
  th: 67, //泰国
  // fr: 68, //法国
  // vn: 69, //越南
  ur: 70, //巴基斯坦
  tr: 71, //土耳其
} as const;
export type Locale = keyof typeof LocaleMap;
export type LocaleValue = (typeof LocaleMap)[Locale];

export const DefaultLocale = "pt";

/** 语言配置 */
export interface LangInfo {
  i18n: string;
  betby: string;
  text: string;
  value: string;
  origin: Locale;
  i18nText: string;
  thousandths: number;
}

// prettier-ignore
export const langConf: Record<LocaleValue, LangInfo> = {
	[LocaleMap.hk]: { i18n: 'zh-HK', betby: 'zh-hk', text: '中文繁體', i18nText: 'ZH-HK', value: '4', origin: 'hk', thousandths: 0 }, //繁体
	[LocaleMap.en]: { i18n: 'en-US', betby: 'en', text: 'English', i18nText: 'EN', value: '1', origin: 'en', thousandths: 0 }, //英语
	[LocaleMap.pt]: { i18n: 'pt-BR', betby: 'pt-br', text: 'Português(BR)', i18nText: 'PT', value: '11', origin: 'pt', thousandths: 1 }, //葡萄牙语
	[LocaleMap.es]: { i18n: 'es-ES', betby: 'es-es', text: 'Español', i18nText: 'ES', value: '12', origin: 'es', thousandths: 1 }, //西班牙语
	[LocaleMap.ru]: { i18n: 'ru-RU', betby: 'ru-ru', text: 'Русский', i18nText: 'RU', value: '64', origin: 'ru', thousandths: 2 }, //俄语
	[LocaleMap.ph]: { i18n: 'tl-PH', betby: 'tl-ph', text: 'Filipino', i18nText: 'TL', value: '61', origin: 'ph', thousandths: 0 }, //菲律宾语
	[LocaleMap.hi]: { i18n: 'hi-IN', betby: 'hi-in', text: 'हिंदी', i18nText: 'HI', value: '63', origin: 'hi', thousandths: 0 }, ////印地语
	[LocaleMap.th]: { i18n: 'th-TH', betby: 'th-th', text: 'แบบไทย', i18nText: 'TH', value: '67', origin: 'th', thousandths: 0 }, //泰语
	[LocaleMap.tr]: { i18n: 'tr-TR', betby: 'tr-tr', text: 'Türkçe', i18nText: 'TR', value: '71', origin: 'tr', thousandths: 0 }, //土耳其语
	[LocaleMap.ur]: { i18n: 'ur-PK', betby: 'ur-pk', text: 'اردو',i18nText: 'PK', value: '70', origin: 'ur', thousandths: 0 }, //巴基斯坦 乌尔都语
  /**  暂无翻译 */
	/* [LocaleMap.kr]: { i18n: 'ko-KR', betby: 'ko-kr', text: '한국인', i18nText: 'KO', value: '60', origin: 'kr', thousandths: 0 }, //韩语
	[LocaleMap.id]: { i18n: 'id-ID', betby: 'id-id', text: 'Indonesia', i18nText: 'ID', value: '5', origin: 'id', thousandths: 1 }, //印度尼西亚语
	[LocaleMap.jp]: { i18n: 'ja-JP', betby: 'ja-jp', text: '日本語', i18nText: 'JP', value: '62', origin: 'jp', thousandths: 0 }, //日语
	[LocaleMap.bd]: { i18n: 'bn-BD', betby: 'bn-bd', text: 'বাংলা', i18nText: 'BN', value: '65', origin: 'bd', thousandths: 0 }, //孟加拉语
	[LocaleMap.my]: { i18n: 'ms-MY', betby: 'ms-my', text: 'Melayu', i18nText: 'MS', value: '66', origin: 'my', thousandths: 0 }, //马来语
	[LocaleMap.fr]: { i18n: 'fr-FR', betby: 'fr-fr', text: 'Français', i18nText: 'FR', value: '68', origin: 'fr', thousandths: 0 }, //法语
	[LocaleMap.vn]: { i18n: 'vi-VN', betby: 'vi-vn', text: 'Tiếng Việt', i18nText: 'VN', value: '69', origin: 'vn', thousandths: 0 }, //越南语 */
}
